import React from "react";
import { Layout, Menu, Icon } from "antd";
import { Switch, BrowserRouter, Route, Link, Redirect } from "react-router-dom";
import Login from "./pages/login";

import "./App.css";

import Homepage from "./pages/homePage";
class App extends React.Component {
  render() {
    return (
      <Layout style={{ height: "100%" }}>
        <BrowserRouter>
          <Route
            path="/"
            exact
            render={() => <Redirect to="/page"></Redirect>}
          ></Route>
          <Route path="/page" component={Homepage}></Route>
          <Route path="/login" component={Login}></Route>
        </BrowserRouter>
      </Layout>
    );
  }
}

export default App;
